

























































import { defineComponent, computed, PropType } from '@vue/composition-api';
import { i18n } from '@tt4b/ttam-i18n';

const name = 'ttam-tracking-viewability-input';

export default defineComponent({
  name,

  props: {
    url: { type: String, default: '' },
    type: { type: Number, default: undefined },
    isIASSelect: { type: Boolean, default: false },
    isOnlyShowViewIAS: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    isOnlyOneViewTrackType: { type: Boolean, default: false },
    options: {
      type: Array as PropType<{ value: string; label: string }[]>,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: i18n.t('module_track_url_ias_placeholder'),
    },
  },

  setup(props, ctx) {
    const _url = computed({
      get: () => props.url,
      set: val => ctx.emit('url-change', val),
    });

    const _type = computed({
      get: () => props.type,
      set: val => ctx.emit('type-change', val),
    });

    return {
      name,
      _url,
      _type,
    };
  },
});
